// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date-picker-btn{border-radius:50px;box-shadow:0 0 4px 0 #00000040;width:100%;cursor:pointer}.close-icon{position:absolute;left:8px;top:8px;cursor:pointer}.mdi-calendar-end:before,.mdi-calendar-start:before{color:var(--fc13365e)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
